import { HSpacer, Text, VSpacer } from '@/components/DesignSystem';
import { getLoyaltyPointsText, getPointsCapProgressText } from '@/utilities/PromotionUtils';
import { ApiPromotion } from '@api/interfaces';
import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface LoyaltyPointsCapProgressProps {
  promotion: ApiPromotion,
}

export const LoyaltyPointsCapProgress = ({
  promotion,
}: LoyaltyPointsCapProgressProps) => {
  const { t } = useTranslation();
  if (!promotion.pointCap) {
    return null;
  }
  return (
    <>
      <Text category="title-small">
        {t($ => $.promotions.loyaltyCap.title)}
      </Text>
      <VSpacer size="2" />
      <Stack alignItems="center" direction="row">
        <Text category="body-small">
          {getLoyaltyPointsText(promotion, t)}
        </Text>
        <HSpacer size="2" />
        •
        <HSpacer size="2" />
        <Text category="body-small">
          {getPointsCapProgressText(promotion, t)}
        </Text>
      </Stack>
    </>
  );
};
